module.exports = __webpack_public_path__ + "static/media/us.23f83ac4.svg";